// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__IQPjH","formItem":"styles_formItem__zyy0I","formFull":"styles_formFull__Iu5jc","InputNumber":"styles_InputNumber__OCVNu"};